import {
  FilterOption,
  Filter
} from '../../../components/_WMS/FilterComponent/types'
import { Courier } from '../../../interfaces/Courier/Courier'
import { TypeOrder } from '../../../interfaces/Order/TypeOrder'
import { Warehouse } from '../../../interfaces'
import { ProductOrigin } from '../../../interfaces/Producto/ProductOrigins'

// Configuración de filtros por defecto
export const defaultFilterOptions: FilterOption[] = [
  {
    order: 2,
    key: 'referenceId',
    label: 'ID de Pedido',
    type: 'text'
  },
  {
    order: 3,
    key: 'courierId',
    label: 'Courier',
    type: 'precreated',
    options: []
  },
  {
    order: 4,
    key: 'courierServiceId',
    label: 'Servicio',
    type: 'precreated',
    options: []
  },
  {
    order: 5,
    key: 'typeOrderId',
    label: 'Tipo de Pedido',
    type: 'precreated',
    options: []
  },
  {
    order: 6,
    key: 'orderOriginId',
    label: 'Canal de Venta',
    type: 'precreated',
    options: []
  },
  {
    order: 7,
    key: 'orderStateId',
    label: 'Estado del Pedido',
    type: 'precreated',
    options: [],
    canBeRepeated: true
  },
  {
    order: 8,
    key: 'deliveryDateRange',
    label: 'Rango de Fecha de Entrega',
    type: 'daterange'
  },
  {
    order: 9,
    key: 'createdDateRange',
    label: 'Rango de Fecha de Creación',
    type: 'daterange'
  },
  {
    order: 10,
    key: 'quantity',
    label: 'Cantidad',
    type: 'numeric'
  },
  {
    order: 11,
    key: 'sku',
    label: 'SKU',
    type: 'text'
  },
  {
    order: 12,
    key: 'productOriginId',
    label: 'Marca',
    type: 'precreated'
  }
]

// Filtros por defecto aplicados
export const defaultFilters: Filter[] = [
  // Aquí se pueden definir filtros que se apliquen por defecto
  // Por ejemplo, mostrar solo pedidos activos
  {
    key: 'ordersWithWorkOrder',
    value: false,
    label: 'Incuir pedidos con OT',
    displayValue: 'No'
  },
  {
    key: 'orderStateId',
    value: 1,
    label: 'Estado',
    displayValue: 'Creado'
  },
  {
    key: 'orderStateId',
    value: 4,
    label: 'Estado',
    displayValue: 'Espera de stock'
  }
]

// Función para actualizar las opciones de filtros dinámicamente
export const updateFilterOptions = (
  couriers: Courier[],
  typesOrder: TypeOrder[],
  warehouses: Warehouse[],
  productOrigins: ProductOrigin[]
): FilterOption[] => {
  return defaultFilterOptions.map((option) => {
    // Poblar opciones de courier
    if (option.key === 'courierId' && couriers) {
      return {
        ...option,
        options: couriers.map((courier) => ({
          label: courier.name,
          value: courier.courierId
        }))
      }
    }

    // Poblar opciones de tipo de orden
    if (option.key === 'typeOrderId' && typesOrder) {
      return {
        ...option,
        options: typesOrder.map((type) => ({
          label: type.name,
          value: type.typeOrderId
        }))
      }
    }

    // Poblar opciones de bodega
    if (option.key === 'warehouseId' && warehouses) {
      return {
        ...option,
        options: warehouses.map((warehouse) => ({
          label: warehouse.warehouseName,
          value: warehouse.id
        }))
      }
    }

    // Poblar opciones de estado de pedido (estados fijos)
    if (option.key === 'orderStateId') {
      return {
        ...option,
        options: [
          { label: 'Creado', value: 1 },
          { label: 'En Espera De Stock', value: 4 },
          { label: 'En Prepración', value: 5 },
          { label: 'Solicitud De Cancelación', value: 2 },
          { label: 'Cancelado', value: 3 },
          { label: 'Gestión Completada', value: 6 }
        ]
      }
    }

    // Poblar opciones de product origin (marca)
    if (option.key === 'productOriginId' && productOrigins) {
      return {
        ...option,
        options: productOrigins.map((productorigin) => ({
          label: productorigin.name,
          value: productorigin.productOriginId
        }))
      }
    }

    return option
  })
}
